import { useHome } from '@/lib/hooks/useHome';
import { useReadinessFormula } from '@/lib/hooks/useReadiness';
import { ReadinessBreakdown } from '@/features/Readiness';

/**
 * Student-side container for the readiness breakdown.
 *
 * Both the values and the weights come from the API (`/lms/home` carries the
 * scored breakdown, `/lms/readiness/formula` the definition). Nothing here
 * restates a weight — the previous version listed five components with weights
 * written into a comment, which is exactly how the UI drifted from the scorer.
 *
 * Both queries are shared with the rest of the page through the query cache,
 * so mounting this alongside BiggestLeverCard costs no extra request.
 */
export function ScoreBreakdown({ batchId }: { batchId: string }) {
  const { data: home, isLoading } = useHome(batchId);
  const { data: formula } = useReadinessFormula();
  const readiness = home?.readiness;

  if (isLoading && !readiness) {
    return (
      <section aria-label="Score breakdown">
        <div className="h-40 animate-pulse rounded-xl bg-muted" />
      </section>
    );
  }

  return (
    <ReadinessBreakdown
      breakdown={readiness?.breakdown}
      formula={formula}
      computedAt={readiness?.computed_at}
    />
  );
}
